// useFeedState.js
// Pure state container for all feed-related state.
// Uses cursor-based pagination (X-style).
//
// Each feed tracks:
//   *HasMore — starts false; set to true/false by bootstrap after first fetch
//   *Loading — in-flight request guard
import { useState } from "react";

export function useFeedState() {
  /* ── Following feed ── */
  const [feedPosts,    setFeedPosts]    = useState([]);
  const [feedHasMore,  setFeedHasMore]  = useState(false); // set by bootstrap
  const [feedLoading,  setFeedLoading]  = useState(false);

  /* ── Global (For You) feed ── */
  const [globalLivePosts,  setGlobalLivePosts]  = useState([]);
  const [globalHasMore,    setGlobalHasMore]    = useState(false);
  const [globalLoading,    setGlobalLoading]    = useState(false);

  /* ── Interactions ── */
  const [interactionPosts,   setInteractionPosts]   = useState([]);
  const [interactionHasMore, setInteractionHasMore] = useState(false);
  const [interactionLoading, setInteractionLoading] = useState(false);

  /* ── My Posts ── */
  const [myPostsHasMore, setMyPostsHasMore] = useState(false);
  const [myPostsLoading, setMyPostsLoading] = useState(false);

  /* ── Notifications ── */
  const [notificationCounts, setNotificationCounts] = useState([]);

  /* ── Interaction meta ── */
  const [interactionActivity, setInteractionActivity] = useState({});
  const [interactionCounts,   setInteractionCounts]   = useState({});

  return {
    /* Following */
    feedPosts,        setFeedPosts,
    feedHasMore,      setFeedHasMore,
    feedLoading,      setFeedLoading,
    /* Global */
    globalLivePosts,  setGlobalLivePosts,
    globalHasMore,    setGlobalHasMore,
    globalLoading,    setGlobalLoading,
    /* Interactions */
    interactionPosts,   setInteractionPosts,
    interactionHasMore, setInteractionHasMore,
    interactionLoading, setInteractionLoading,
    /* My Posts */
    myPostsHasMore, setMyPostsHasMore,
    myPostsLoading, setMyPostsLoading,
    /* Notifications */
    notificationCounts, setNotificationCounts,
    /* Interaction meta */
    interactionActivity, setInteractionActivity,
    interactionCounts,   setInteractionCounts,
  };
}